





















































































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import FilterComponent from "./Filter/Filter.vue";
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";
import { Workspace, ApplicationSubmit } from "@/entities";
import { Locales } from "@/i18n/locales";

const namespace: string = "application";

@Component({
  components: {
    FilterComponent,
  },
})
export default class ApplicationListComponent extends Vue {
  @State(namespace) application!: Workspace;
  @Action("getApplication", { namespace }) getApplication: any;
  @Action("resetAppState", { namespace }) resetAppState: any;
  @Action("setApplicationId", { namespace }) setApplication: any;
  @Getter("rootTemplate", { namespace }) schema: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("projectYrs", { namespace: "application" }) years: any;
  @Getter("reportingFrequency", { namespace: "application" }) reportingFreq: any;
  @Getter("appSubmit", { namespace }) appSubmit: ApplicationSubmit;
  countLoop: number = 0;
  dataLength: number = 0;
  Edit: boolean = true;
  // calls: Array<any> = [];
  defaultData: Array<any> = [];
  uploadReady: boolean = true;
  appStatus: any = _app.applicationStatus;
  actions = _app.actions;
  subjects = _app.subjects;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  @Prop() calls!: any;

  data() {
    var self = this;
    return { items: self.calls, Edit: self.Edit };
  }

  get appItems() {
    return this.calls;
  }

  formatCurrency(val, currency) {
    return utils.formatCurrency(val, currency, this.defaultLocale);
  }

  listProposal() {
    return http.get(`/api/AdminDashboard`).then((resp: any) => {
      return resp.data.Items;
    });
  }

  /** Edit Proposal */
  editProposal(proposalId) {
    var self = this;
    this.resetAppState();
    this.setApplication(proposalId);
    this.$router.push({
      name: "applicationSummary",
      params: { applicationId: proposalId }
    });
  }

  /** Delete Proposal*/
  deleteProposal(proposalId) {
    let self = this;
    const id =
      typeof proposalId == "string" ? parseInt(proposalId) : proposalId;
    if (confirm("Are you sure to delete this application?")) {
      this.$services.application.deleteApplication(id).then((data: any) => {
        if (data.Result === "OK") {
          this.listProposal().then((data: any) => {
            self.calls = data;
          });
        }
      });
    }
  }

  /** download the pdf file */
  download(proposalId) {    
    let self = this;
    const appId =
      typeof proposalId === "string" ? parseInt(proposalId) : proposalId;
    this.getApplication(appId).then((data: any) => {
      if (data && data.projectTitle) {
        this.generatePdf();
      }
    });
  }

  /** method to generate the pdf file */
  generatePdf() {    
  //    const applicationData = this.application.data.hasOwnProperty("amountOfMatchingFund")
  // ? this.application.data
  // : {
  //     ...this.application.data,
  //     amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding
  //   };
    // const applicationData =this.application.application.BudgetType == 'Tiger' ? { ...this.application.data, amountOfMatchingFund:  this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0 } : this.application.data;
     let applicationData;

switch (this.application.application.BudgetType) {
  case 'Tiger':
    applicationData = {
      ...this.application.data,
      amountOfMatchingFund: this.application.data.applicationBudget.summary.totalBudget.matchFunding || 0
    };
    break;
  case 'CAG':
    applicationData = {
      ...this.application.data,
      fundingRequests: this.application.data.totalProjectBudgect || 0
    };
    break;
  default:
    applicationData = this.application.data;
    break;
}
    this.$services.pdf.generate({
      entity: "Application",
      schema: this.schema,
      data: applicationData,
      user: this._username,
      currency: this.application.application.BudgetCurrency,
      id: this.application.application.ApplicationId,
      code: this.application.application.Code,
      type: this.application.templates["IsRAGTemplate"] ? "RAG" : "TSG",
      "years":this.years,
      "Quaters":this.reportingFreq,
      "checklist": this.appSubmit.checklist,
      "logSchema": this.application.logSchema
    });
  }

  /*callProposalCallFilter*/
  callProposalCallFilter(e) {
    var self = this;
    http.get(`/api/AdminDashboard?${e}`).then((resp: any) => {
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
      self.calls = resp.data.Items;
    });
  }

  buttonVisibility(card, context) {
    let show = false;

    switch (context) {
      case "view":
        //@ts-ignore
        if (this.$can(this.actions.read, this.subjects.applicationReadonly)) {
          show = true;
        }
        break;

      case "delete":
        //@ts-ignore
        if ((!this.$can(this.actions.read, this.subjects.applicationReadonly) && 
          _app.workflowStatusCode.draft.includes(card.StatusCode) || card.StatusId == this.appStatus.draft || card.StatusId == 148)
        ) {
          show = true;
        }
        break;

      default:
        //@ts-ignore
        if (!this.$can(this.actions.read, this.subjects.applicationReadonly)) {
          show = true;
        }
        break;
    }

    return show;
  }
}
